import FooterControl from '@/components/FooterControl.vue';
import { ORDER_TYPE_OPTION } from '@/config/constant';
import { BigNumber } from 'bignumber.js';
import { getLodop } from '@/plugins/LodopFuncs.js';
import { medTypeFilter, getHiMedType } from '@/utils/util';

// 打印相关
import medicinePrint from '@/components/medicinePrint/index.vue'; // 成药处方打印
import receiptPrint from '@/components/receiptPrint/index.vue'; // 小票打印f
import piecesPrint from '@/components/piecesPrint/index.vue'; // 饮片打印
import infusionPrint from '@/components/infusionPrint/index.vue'; // 输液打印
import applyPrint from '@/components/applyPrint/index.vue'; // 敷贴打印
import otherPrint from '@/components/otherPrint/index.vue'; // 其他打印
import infusionCardPrint from '@/components/infusionCardPrint/index.vue'; // 输液打印卡
import noPrintTips from '@/components/noPrintTips.vue';
import insuReceiptPrint from '@/components/insuReceiptPrint/index.vue'; // 医保收费单打印
import invoicePrint from '@/components/invoicePrint/index.vue'; // 医保收费单发票打印
import ybjsPrint from '@/components/ybjsPrint/index';
import recordPrint from '@/components/recordPrint/index.vue';
import ExternalPrint from "@/components/externalPrint/index.vue";
import {getSettlementPrintDrugAPI} from "@/api/newInsurance";

const BN = BigNumber.clone();
BN.config({ DECIMAL_PLACES: 2 });

export default {
  name: 'sale-drug',
  components: {
    FooterControl,
    medicinePrint,
    receiptPrint,
    piecesPrint,
    infusionPrint,
    infusionCardPrint,
    applyPrint,
    otherPrint,
    noPrintTips,
    insuReceiptPrint,
    invoicePrint,
    ybjsPrint,
    recordPrint,
    ExternalPrint,
  },
  data () {
    return {
      tableData: [],
      patient: {
        patientName: '--',
        genderStr: '--',
        age: '-',
        ageType: '-',
      },
      orderType: '',
      fee: { hiMedType: '--' },
      isSale: false,
      records: [], // 收费记录
      salePrescription: [], // 直接售药
      wPrescription: [], // 西药处方
      ePrescription: [], // 中药处方
      infusionPrescription: [], // 输液卡处方
      applyPrescription: [], // 贴敷
      patientStickingListApplication: [],//外治处方-贴敷
      patientStickingListAcupuncture: [],//外治处方-针刺
      patientStickingListMoxibustion: [],//外治处方-艾灸
      patientStickingListCupping: [],//外治处方-拔罐
      inquiryInfo: {

      }, // 病例
      orderBalance: {
        alipayAmt: 0, // 支付宝支付
        cashAmt: 0, // 现金
        commercialInsurance: 0, // 商业保险支付
        medicalInsurance: 0, // 医保支付
        otherAmt: 0, // 其他支付
        posAmt: 0, // 银行卡支付
        remainingAmt: 0, // 余额支付
        wechatAmt: 0, // 微信支付
        wechatAppsAmt: 0, // 微信小程序支付
        wechatPayAmt: 0, // 微信当面付
        debtAmt: 0, // 欠费
        refundAmt: 0, // 欠费抵扣
        medicalIndividual: 0,//医保个账
        medicalMutualAid: 0,//医保共济
        memberAmt: 0,// 会员支付
      },
      // 订单结算方式
      orderExamList: [], // 检查项
      orderAdditionList: [], // 附加费用
      printShow: false,
      review: false, // 打印预览
      showInsuReceipt: false, // 医保收费单
      scriptList: {},
      record: {
        patient: {
          patientName: '',
        },
        inquiryInfo: {
          diagnosisResultString: '',
        },
        medicineDrugPrescriptionList: [
          {
            patientDrugList: [],
          },
        ],
        patientChineseDrugList: [],
        patientInfusionList: [],
      },
      ageString: '',
      orderNo: '',//订单号
      settlementObj: {},//医保结算信息
      invoiceObj: {},//发票信息
      recordPrint: {},
      patientItemDiagnosisList: [],
      isOpenMemberPay: false,//是否开启会员支付
    };
  },

  methods: {
    getHiMedType,
    goback () {
      this.$router.go(-1);
    },
    getFeeDetail() {
      const { id } = this.$route.query;
      this.$api.feeDispense.completedDetail({ id }).then((res) => {
        console.log("🚀 ~ file: index.js:107 ~ this.$api.feeDispense.completedDetail ~ res:", res)
        // 会员支付开始
        this.isOpenMemberPay = res.memberCardNo ? true : false;
        this.orderNo = res.orderNo
        // 判断有没有患者信息
        if (this.patient && this.patient.patientName) {
          this.patient = res.patient;
        }
        this.ageString = res.patient.clinicalAge
        this.orderType = ORDER_TYPE_OPTION.find(it => res.orderType === it.value).label;
        this.fee = res;
        this.inquiryInfo = res.inquiryInfo;
        this.records = res.records;
        this.$store.state.global.countInfo.laboratoryName = this.inquiryInfo.laboratoryName;
        // console.log("externalArr===1111this.inquiryInfo", this.inquiryInfo);
        // 直接售药
        this.salePrescription = res.orderPrescriptionList.filter(item => item.type === 5);
        this.wPrescription = res.orderPrescriptionList.filter(item => item.type === 1);
        this.ePrescription = res.orderPrescriptionList.filter(item => item.type === 2);
        this.infusionPrescription = res.orderPrescriptionList.filter(item => item.type === 6);
        this.applyPrescription = res.orderPrescriptionList.filter(item => item.type === 7);

        // this.patientStickingListApplication = res.orderPrescriptionList.filter(item => item.type === 9);//外治处方-贴敷
        // this.patientStickingListAcupuncture = res.orderPrescriptionList.filter(item => item.type === 10);//外治处方-针刺
        // this.patientStickingListMoxibustion = res.orderPrescriptionList.filter(item => item.type === 11);//外治处方-艾灸
        // this.patientStickingListCupping = res.orderPrescriptionList.filter(item => item.type === 12);//外治处方-拔罐
        const externalArr = [...res.orderPrescriptionList, ...res.orderItemDiagnosisList];
        this.patientStickingListApplication = externalArr.filter(item => item.type === 9);//外治处方-贴敷
        this.patientStickingListAcupuncture = externalArr.filter(item => item.type === 10);//外治处方-针刺
        this.patientStickingListMoxibustion = externalArr.filter(item => item.type === 11);//外治处方-艾灸
        this.patientStickingListCupping = externalArr.filter(item => item.type === 12);//外治处方-拔罐

        this.orderExamList = res.orderExamList;
        this.patientItemDiagnosisList = res.orderItemDiagnosisList.filter(item => (item.type === 20 || item.type === 21 || item.type === 22 || item.type === 23  || item.type === 24  || item.type === 25));
        this.orderAdditionList = res.orderAdditionList;
        this.getBalance();
        // 直接售药处方打印
        if (this.fee.orderType === 2) {
          this.isSale = true;
          this.record = {
            // applicationList: this.patientStickingListApplication,// 外治处方-贴敷
            // acupunctureList: this.patientStickingListAcupuncture,// 外治处方-针刺
            // moxibustionList: this.patientStickingListMoxibustion,// 外治处方-艾灸
            // cuppingList: this.patientStickingListCupping,// 外治处方-拔罐
            saleDrugPrescriptionList: this.salePrescription,
            patient: res.patient,
            patientChineseDrugList: this.ePrescription,
            patientInfusionList: this.infusionPrescription,
            patientStickingDrugGroupList: this.applyPrescription,
            inquiryInfo: res.inquiryInfo,
            examList: this.orderExamList,
            patientItemDiagnosisList: this.patientItemDiagnosisList,
            additionalList: this.orderAdditionList,
          };
        } else {
          this.isSale = false;
        }
        if (this.fee.orderType !== 2) {
          this.getRecord();
        }
        this.getSmallTicketPrint();
      });
    },
    // 获取病历
    getRecord () {
      this.$api.outPatient.getRecord({ recordId: this.inquiryInfo.recordId }).then((res) => {
        this.record = res;
      });
    },
    // 获取支付方式
    getBalance () {
      const orderBalanceList = Object.keys(this.orderBalance);
      this.records.forEach((record) => {
        // 如果是退费就减掉付款方式上的金额
        const def = record.operateType === 2 ? 'minus' : 'plus';
        orderBalanceList.forEach((balance) => {
          const recordBalanceItem = record.recordBalance.find(it => it.payModesLabel === balance);
          if (recordBalanceItem) {
            this.orderBalance[balance] = BN(this.orderBalance[balance])[def](recordBalanceItem.amt).toFixed(2);
          }
        });
      });
    },
    totalPrice (count, price) {
      return BN(price).multipliedBy(count).toFixed(2);
    },
    totalPriceSticker (count, gramCount, price) {
      return BN(price).multipliedBy(count).multipliedBy(gramCount).toFixed(2);
    },
    // 直接售药数量计算
    saleDrugNum (dosage, gramCount) {
      return BN(dosage).multipliedBy(gramCount).toString();
    },
    // 饮片处方数量
    eNum (gramCount, saleUnit, dosage) {
      if (dosage === 1) {
        return gramCount + saleUnit;
      }
      return `${gramCount}${saleUnit}*${dosage}`;
    },
    goRefund () {
      const { id } = this.$route.query;
      this.$router.push({ name: 'returd', query: { id } });
    },
    // 打印小票
    print () {
      const LODOP = getLodop();
      if (!LODOP) {
        this.printShow = true;
        return;
      }
      // 打印事件
      this.$notify({
        title: '友情提示',
        message: '正在打开预览...',
        type: 'success',
      });
      this.$refs.receiptPrint.print();
    },
    // 打印医保收费单
    insuPrint () {
      const params = {
        orderNo: this.orderNo
      }

      // 定点药店购药就掉这个接口 getSettlementPrintDrugAPI
      let getSettlementPrintFn = (params) => {
        if (this.fee.hiMedType == 41) {
          return this.$api.newInsurance.getSettlementPrintDrugAPI(params)
        } else {
          return this.$api.newInsurance.getSettlementPrintAPI(params)
        }
      }


      getSettlementPrintFn(params).then((res) => {
        // console.log(res,'res');
        if (res.data.code === 200 && res.data.data) {
          this.settlementObj = {
            ...res.data.data,
            orderNo: this.orderNo
          }
          const LODOP = getLodop();
          if (!LODOP) {
            this.printShow = true;
            return;
          }
          // 打印事件
          this.$notify({
            title: '友情提示',
            message: '正在打开预览...',
            type: 'success',
          });
          this.$refs.insuReceiptPrint.print({ isReview: true });
        } else {
          return this.$notify({ title: '友情提示', message: '未获取结算信息...', type: 'error', });
        }
      })
    },
    // 打印发票
    invoicePrint () {
      const params = {
        id: this.$route.query.id
      }
      this.$api.feeDispense.invoiceDetailAPI(params).then((res) => {
        console.log(res,'res');
        this.invoiceObj = res
        const LODOP = getLodop();
        if (!LODOP) {
          this.printShow = true;
          return;
        }
        // 打印事件
        this.$notify({
          title: '友情提示',
          message: '正在打开预览...',
          type: 'success',
        });
        this.$refs.invoicePrint.print({ isReview: true });
      })
    },
    // 打印处方
    printScript () {
      const LODOP = getLodop();
      if (!LODOP) {
        this.printShow = true;
        return;
      }
      // 直接售药就直接取详情的处方
      if (this.fee.orderType === 2) {
        if (this.record.saleDrugPrescriptionList.length > 0) this.$refs.salePrint.print();
        if (this.record.examList.length > 0 || this.record.additionalList.length > 0) this.$refs.otherPrint.print();
        if (this.record.patientItemDiagnosisList.length > 0 || this.patientItemDiagnosisList.additionalList.length > 0) this.$refs.otherPrint.print();
        return;
      }
      // 门诊过来的药需要recorId来查
      this.$notify({
        title: '友情提示',
        message: '正在打印请稍后...',
        type: 'success',
      });

      if (this.record.medicineDrugPrescriptionList.length > 0) this.$refs.medicinePrint.print();
      if (this.record.patientChineseDrugList.length > 0) this.$refs.piecesPrint.print();
      if (this.record.patientInfusionList.length > 0) this.$refs.infusionPrint.print();
      if (this.record.patientStickingDrugGroupList.length > 0) this.$refs.applyPrint.print();
      if (this.record.examList.length > 0 || this.record.additionalList.length > 0) this.$refs.otherPrint.print();
      if (this.record.patientItemDiagnosisList.length > 0) this.$refs.otherPrint.print();
    },
    printReview (name) {
      if (name === 'medicineDrugPrescriptionList') this.$refs.medicinePrint.print({ isReview: true });
      if (name === 'patientChineseDrugList') this.$refs.piecesPrint.print({ isReview: true });
      if (name === 'patientInfusionList') this.$refs.infusionPrint.print({ isReview: true });
      if (name === 'patientStickingDrugGroupList') this.$refs.applyPrint.print({ isReview: true });
      if (name === 'examList' || name === 'additionalList') this.$refs.otherPrint.print({ isReview: true });
      if (name === 'patientItemDiagnosisList') this.$refs.otherPrint.print({ isReview: true });
    },
    printMedicalRecord() {
      // 打印拦截如果没有安装打印机插件
      const LODOP = getLodop();
      if (!LODOP) {
        this.printShow = true;
        return;
      }
      this.$notify({
        title: '友情提示',
        message: '正在打开预览...',
        type: 'success',
      });
      this.$refs.recordPrint.print();
    },
    // 打印输液单
    printInfusionScript () {
      const LODOP = getLodop();
      if (!LODOP) {
        this.printShow = true;
        return;
      }
      this.$api.outPatient.getRecord({ recordId: this.inquiryInfo.recordId }).then((res) => {
        this.record = res;
        this.$notify({
          title: '友情提示',
          message: '正在打开预览...',
          type: 'success',
        });
        if (res.patientInfusionList.length > 0) this.$refs.infusionCardPrint.print();
      });
    },
    recordsFavorable (item) {
      return BN(item.couponDiscountAmt)
        .plus(item.discountAmt)
        .plus(item.wipeAmt)
        .toFixed(2);
    },
    getSmallTicketPrint () {
      const orderId = this.$route.query.id;
      const changeData = (item) => {
        item.receivableAmt = item.amt;
        item.items = item.orderItemDetailedList.map(it => ({
          drugName: it.designation,
          dose: it.dosage,
          dosage: it.totalDosage,
          saleUnit: it.unit,
          salePrice: it.price,
          amtName: it.designation, // 附加费用名称
          count: it.totalDosage,
        }));
        return item;
      };
      this.$api.feeDispense.smallTicketPrint({ orderId }).then((res) => {
        console.log("item打印数据的获取=", res)
        // 是否是直接售药的
        if (this.isSale) {
          const obj = {};
          const saleDrugPrescriptionList = res.orderDetailedLists.filter(item => item.type === 5).map(changeData);
          const orderExam = res.orderDetailedLists.filter(item => item.type === 3).map(changeData);
          const patientItemDiagnosis = res.orderDetailedLists.filter(item => (item.type === 20 || item.type === 21 || item.type === 22 || item.type === 23  || item.type === 24  || item.type === 25)).map(changeData);
          const orderAddition = res.orderDetailedLists.filter(item => item.type === 4).map(changeData);
          if (saleDrugPrescriptionList.length > 0) {
            obj.saleDrugPrescriptionList = saleDrugPrescriptionList[0];
          }
          if (orderExam.length > 0) {
            obj.orderExam = orderExam[0];
          }
          if (patientItemDiagnosis.length > 0) {
            obj.patientItemDiagnosis = patientItemDiagnosis;
          }
          if (orderAddition.length > 0) {
            obj.orderAddition = orderAddition[0];
          }
          obj.totalDiscountAmt = res.discountAmt;
          obj.receivableAmt = res.totalAmt;
          obj.actualReceivableAmt = BN(res.totalAmt).minus(res.discountAmt).toFixed(2);
          obj.cashier = res.cashier; // 收费员
          this.scriptList = obj;

        } else {
          this.scriptList = {
            patientStickingListApplication: res.orderDetailedLists.filter(item => item.type === 9).map(changeData),//外治处方-贴敷
            patientStickingListAcupuncture: res.orderDetailedLists.filter(item => item.type === 10).map(changeData),//外治处方-针刺
            patientStickingListMoxibustion: res.orderDetailedLists.filter(item => item.type === 11).map(changeData),//外治处方-艾灸
            patientStickingListCupping: res.orderDetailedLists.filter(item => item.type === 12).map(changeData),//外治处方-拔罐
            saleDrugPrescriptionList: res.orderDetailedLists.filter(item => item.type === 5).map(changeData),
            medicineDrugPrescriptionList: res.orderDetailedLists.filter(item => item.type === 1).map(changeData),
            patientChineseDrugList: res.orderDetailedLists.filter(item => item.type === 2).map(changeData),
            patientInfusionList: res.orderDetailedLists.filter(item => item.type === 6).map(changeData),
            patientStickingDrugGroupList: res.orderDetailedLists.filter(item => item.type === 7).map(changeData),
            orderExam: res.orderDetailedLists.filter(item => item.type === 3).map(changeData),
            patientItemDiagnosis: res.orderDetailedLists.filter(item => (item.type === 20 || item.type === 21 || item.type === 22 || item.type === 23  || item.type === 24  || item.type === 25)).map(changeData),
            orderAddition: res.orderDetailedLists.filter(item => item.type === 4).map(changeData),
            totalDiscountAmt: res.discountAmt,
            receivableAmt: res.totalAmt,
            actualReceivableAmt: BN(res.totalAmt).minus(res.discountAmt).toFixed(2),
            cashier: res.cashier, // 收费员
          };
          console.log("直接售药=", res)
        }
        const timeList = this.records.filter(item => item.operateType === 1);
        this.scriptList.createDate = timeList[timeList.length - 1] && timeList[timeList.length - 1].createDate;
        this.scriptList.patientName = this.patient.patientName;
        this.scriptList.realName = this.fee.realName;
      });
    },
    handleClick (orderNo, type) {
      console.log(orderNo,type)
      this.$api.newInsurance.getPrintAPI({ orderNo: orderNo }).then(res => {
        if (res.data.code === 200) {
          this.recordPrint = res.data.data // 打印结算单
          if (type === '预览') {
            this.$refs.ybjsPrintRef.print({ isReview: true });
          } else {
            this.$notify({ title: '友情提示', message: '正在打印请稍后...', type: 'success', });
            // this.$refs.ybjsPrintRef.print();
          }

        } else {
          return this.$notify({ title: '友情提示', message: res.data.message, type: 'error', });
        }
      })
    },
    // 外治处方打印预览
    externalPrintView({ name = "", index = -1, title =  "", type =  -1 } = {}) {
      this.selectPrintIndex = index;
      this.$notify({
        title: "友情提示",
        message: "正在打印请稍后...",
        type: "success",
      });
      this.$refs.externalPrint.print({
        isReview: true,
        typeIndex: index,
        title: title,
        itemType: type,
        key: name
      });
    },
  },
  filters: {
    typeStr (value) {
      if (value === 1) return '收费';
      if (value === 2) return '退费';
      if (value === 3) return '还款';
      return '';
    },
    staff (value) {
      if (value === 1) return '收费';
      if (value === 2) return '退费';
      if (value === 3) return '收费';
      return '';
    },
    typeString (value) {
      if (value === 1) return '应收';
      if (value === 2) return '实退';
      if (value === 3) return '实收';
      return '';
    },
    medTypeFilter
  },
  computed: {
    favorable () {
      return BN(this.fee.couponDiscountAmt)
        .plus(this.fee.discountAmt)
        .plus(this.fee.wipeAmt)
        .toFixed(2);
    },
    // 欠费数据整理
    debtAmtCmpt () {
      const orderBalanceList = Object.keys(this.orderBalance);
      let result = 0;
      // 所有欠费金额之和
      this.records.forEach((record) => {
        const recordBalanceItem = record.recordBalance.find(it => it.payModesLabel === 'debtAmt');
        if (recordBalanceItem) {
          result = BN(result).plus(recordBalanceItem.amt).toFixed(2);
        }
      });
      // 其他订单之和
      this.records.forEach((record) => {
        if (record.operateType === 3) {
          orderBalanceList.forEach((balance) => {
            const recordBalanceItem = record.recordBalance.find(it => it.payModesLabel === balance);
            if (recordBalanceItem) {
              result = BN(result).minus(recordBalanceItem.amt).toFixed(2);
            }
          });
        }
        if (record.operateType === 2) {
          const recordBalanceItem = record.recordBalance.find(it => it.payModesLabel === 'refundAmt');
          if (recordBalanceItem) {
            result = BN(result).minus(recordBalanceItem.amt).toFixed(2);
          }
        }
      });
      return result;
    },
    // 实收金额是否为0 收费+退费
    hasActualAmt () {
      const arr = Object.keys(this.orderBalance)
      const flag = arr.every((item) => {
        return this.orderBalance[item] == 0 || this.orderBalance[item] == 0.00
      });
      return flag
    },
    isHiSuccess () {
      return this.$store.state.global.isHiSuccess
    },
    // 是否退费
    isRefund () {
      let flag = false;
      if (this.records && this.records.length) {
        this.records.forEach((item) => {
          if (item.operateType == 2) {
            flag = true;
          }
        });
      }
      return flag
    },
    processingMethod () {
      return (item) => {
        const { prescribeProcItemDto, patientChineseDrug } = item
        return `${prescribeProcItemDto.pricessService}，${patientChineseDrug.totalDosage}剂，${patientChineseDrug.totalDosage}煎${prescribeProcItemDto.bagNumber}袋，共煎${prescribeProcItemDto.totalBagNumber}袋，加工费`
      }
    },
  },
  mounted () {
    this.getFeeDetail();
  },
};
